import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class ActivityService {

  constructor(private afdatabase: AngularFireDatabase) { }

  createActivity(activity) {
  	return this.afdatabase.object('activity/' + activity.aid).set(activity);
  }
  getActivity(aid){
  	return this.afdatabase.object('activity/' + aid);
  }
  editActivity(id, history) {
  	return this.afdatabase.object('activity/' + id + '/history/' + history.hid).set(history);
  }
}
